import { Util,Request } from "@xt/xtbase";
const { getOrigin } = Util;
const { XtAxios4 } = Request;

const URL = getOrigin("www") + "/sapi/v4/wallet/";

//充值费率
export function getCurrencyRate(config) {
  return XtAxios4.get(URL + `currency/rate`, config);
}